import Table from './table';
import Select from '../Select';
import { tabsTypes } from '../../conig';
import Alert from '../Alert';
import { getPopupContainer } from '../../../../../../helpers/popUp';

export default function AdditionalSubjects({
  onChange = () => { },
  formValue = {},
  t = (s) => s,
  section = tabsTypes.MONITORING,
  visible = false,
}) {
  return (
    <div className="form-group">
      {visible && (
        <Alert
          message="You can add individual information subjects to your analysis, which will be featured on your dashboard alongside the main selection."
          localKey={`${section}AdditionalSubjects`}
        />
      )}
      <Select
        {...getPopupContainer()}
        options={[
          {
            label: t('Locations'),
            value: 'locations',
          },
          {
            label: t('Stakeholders'),
            value: 'stakeholders',
          },
        ]}
        value={formValue[`${section}AdditionalSubjectsCategory`]}
        label={t('Category')}
        onChange={(v) => onChange(`${section}AdditionalSubjectsCategory`, v)}
      />

      {formValue[`${section}AdditionalSubjectsCategory`] === 'locations' && (
        <Table
          section={section}
          type="locations"
          t={t}
          onChange={(v) => {
            onChange(`${section}FeaturedLocations`, v);
          }}
          value={formValue[`${section}FeaturedLocations`] || []}
        />
      )}

      {formValue[`${section}AdditionalSubjectsCategory`] === 'stakeholders' && (
        <Table
          section={section}
          type="stakeholders"
          t={t}
          onChange={(v) => {
            onChange(`${section}FeaturedStakeholders`, v);
          }}
          value={formValue[`${section}FeaturedStakeholders`] || []}
        />
      )}

    </div>
  );
}
